//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import DfHeader from '../common/df-header.vue';
import NsPhoneNumber from '../../NsPhoneNumber.vue';

import { LocaleMixin, PropsMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'NsInputTelephoneField',
  components: {
    DfHeader,
    NsPhoneNumber,
  },
  mixins: [LocaleMixin, PropsMixin, RulesMixin, ModelMixin({ deep: true })],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: Object,
      default: () => ({ country: '', number: '' }),
    },
  },
  data() {
    return {
      error: false,
    };
  },
  methods: {
    receiveError(error) {
      this.error = error;
    },
  },
};
